<template>
    <v-col :cols="width">
        <v-label v-if="item.props.label">{{ item.props.label }}</v-label>
        
        <v-input :rules="rules" :value="modelData" class="secret-input" ref="input" >
            <template v-if="item.props.tooltip" v-slot:append>
                <v-tooltip
                    top
                >
                    <template v-slot:activator="{ on }">
                        <v-icon v-on="on">mdi-information</v-icon>
                    </template>
                    <div v-html="item.props.tooltip"></div>
                </v-tooltip>
            </template>
        </v-input>

        <v-list flat >
            <v-list-item 
                :key="thisItem.value + index" 
                v-for="(thisItem, index) in orderedItems"
                :class="thisItem.value === lastMoved ? 'moved' : ''"
            >
                <template v-slot:default="{ active }">
                    <v-list-item-content>
                        <NumberIcon
                            style="display: inline;"
                            :number="index + 1" 
                            numberColor="primary" 
                        />

                        <v-list-item-title>{{thisItem.text}}</v-list-item-title>
                    </v-list-item-content>

                    <v-hover v-slot="{ hover }">
                        <v-list-item-action>
                            <v-btn 
                                fab 
                                small 
                                color="primary"
                                :disabled="index === 0"
                                v-on:click="handleOrderChange({ item: thisItem, index: index - 1 })"
                            >
                                <v-icon>mdi-chevron-up</v-icon>
                            </v-btn>
                        </v-list-item-action>
                    </v-hover>

                    <v-hover v-slot="{ hover }">
                        <v-list-item-action>
                            <v-btn 
                                fab 
                                small 
                                color="primary"
                                :disabled="index === orderedItems.length - 1"
                                v-on:click="handleOrderChange({ item: thisItem, index: index + 1 })"
                            >
                                <v-icon>mdi-chevron-down</v-icon>
                            </v-btn>
                        </v-list-item-action>
                    </v-hover>
                </template>
            </v-list-item>
        </v-list>
        
    </v-col>
</template>

<script>

import NumberIcon from '../../components/shared/numberIcon';

export default {
    name: 'OrderableList',
    props: ['item', 'value', 'readonly', 'rules', 'optional', 'width'],
    components: {
            NumberIcon
        },
    data: function () {
        return {
            // Use existing modelData if it exists, otherwise use the default order
            modelData: Array.isArray(this.value) ? this.value : this.item.props.items.map((item) => item.value),
            lastMoved: null
        }
    },
    computed: {
        orderedItems: function () {
            return this.modelData.map((item) => {
                return this.item.props.items.find((thisItem) => thisItem.value === item);
            });
        }
    },
    methods: {
        /**
         * Handle a triggered order change.
         *
         * @param {Object} obj - The object containing the order change data.
         * @param {Object} obj.item - The item that was moved.
         * @param {Number} obj.index - The index the item was moved to.
         */
        handleOrderChange: function ({ item, index }) {
            const currentIndex = this.modelData.indexOf(item.value);

            if (currentIndex >= 0) {
                this.modelData.splice(currentIndex, 1);
                this.modelData.splice(index, 0, item.value);
            }

            this.lastMoved = item.value;

            this.$emit('input', this.modelData);
        },
        
        validate: function () {
            return this.$refs.input.validate();
        }
    }
}
</script>

<style scoped>
@keyframes rollout {
  from {background-color: rgba(95, 96, 98, .12);}
  to {background-color: rgba(95, 96, 98, 0);}
}
.v-list-item.moved {
  animation: rollout 0.75s;
}

.v-list-item__content {
    height: 100%;
    display: flex;
    align-items: start;
    flex-wrap: nowrap;
}

.v-list-item__content > svg {
    min-width: 18px;
    flex: 0 1 auto;
    margin-right: 10px;
}

.v-list-item__title {
    flex: 1 1 auto;
    margin-right: 20px;
    text-wrap: wrap;
}
</style>


// WEBPACK FOOTER //
// src/components/questionnaire_template/orderable-list.vue